const $element = $('[data-toggle]');
const toggleTarget = $element.data('toggle-target');
const $toggleTarget = $(toggleTarget);
const toggleTargetClosest = $element.data('toggle-target-closest');
const $toggleTargetClosest = $element.closest(toggleTargetClosest);
const toggleTargetClass = $element.data('toggle-target-class');
const toggleTargetClosestClass = $element.data('toggle-target-closest-class');

const toggleClickHandler = (event) => {
  event.preventDefault();
  
  if (toggleTarget) $toggleTarget.toggleClass(toggleTargetClass);
  if (toggleTargetClosest) $toggleTargetClosest.toggleClass(toggleTargetClosestClass || toggleTargetClass);
}

const events = () => {
  $element.on('click', toggleClickHandler);
}

const init = () => {
  events();
}

export default init;
